import Modal from 'react-modal';
import React from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../redux/root-action';
import AccountModal from '../Modals/Account/AccountModal';
import AddSpouseProfile from '../Modals/Spouse/AddSpouseProfile';
import SpouseProfile from '../Modals/Spouse/SpouseProfile';
import AddAccountOrSpouse from '../Modals/AddAccountOrSpouse';
import SecurelyAddAccounts from '../Modals/Account/SecurelyAddAccounts';
import IncreaseContribution from '../Modals/IncreaseContribution';
import DelayRetirement from '../Modals/DelayRetirement';
import RetirementAgeModal from '../Modals/RetirementAgeModal';
import RetirementIncomeModal from '../Modals/RetirementIncomeModal';
import ContributionEducationModal from '../Modals/ContributionEducationModal';
import VideoModal from '../EducationContainer/VideoModal';
import DeleteSpouseModal from '../Modals/Spouse/DeleteSpouseModal';
import ChartEducationModal from '../Modals/ChartEducationModal';
import TermedModal from '../Modals/TermedModal';
import SavingsRunOutModal from '../Modals/SavingsRunOutModal';
import ConfidenceNumber from '../Modals/ConfidenceNumber';
import InformationAndAssumptions from '../Modals/InformationAndAssumptions';
import YodleeThirdParty from '../Modals/Account/YodleeThirdParty';
import YodleeIFrame from '../Modals/Account/YodleeIFrame';
import YodleeRedirect from '../Modals/Account/YodleeRedirect';
import DollarValue from '../Modals/DollarValueModal';
import EditChartDisplaySettings from '../Modals/EditChartDisplaySettings';
import RIXAssumptions from '../Modals/RIXAssumptions';
import LearnMoreModal from '../Modals/LearnMoreModal';
import ContributionSourceModal from '../Modals/ContributionSourceModal';
import ContributionPerPaycheckModal from '../Modals/ContributionPerPaycheckModal';
import RIGSalaryModal from '../Modals/RIGSalaryModal';
import RIGOtherIncomeModal from '../Modals/RIGOtherIncomeModal';
import EventModal from '../Modals/Event/EventModal';
import FutureIncomeModal from '../Modals/Event/FutureIncomeModal';
import AddFutureExpense from '../Modals/Event/AddFutureExpense';
import AddFutureIncome from '../Modals/Event/AddFutureIncome';
import DeleteFutureExpense from '../Modals/Event/DeleteFutureExpense';
import DeleteFutureIncome from '../Modals/Event/DeleteFutureIncome';


const desktopStyles = {
  content: {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'visible',
    width: '640px',
    padding: 0,
    boxShadow: '0 16px 16px 0 rgba(45, 57, 64, 0.06), 0 0 8px 0 rgba(45, 57, 64, 0.06)',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 2000,
  },
};

const mobileStyles = {
  overlay: {
    position: 'fixed' as 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    zIndex: 2000,
    width: '100vw',
  },
  content: {
    position: 'absolute' as 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    border: '1px solid #ccc',
    background: '#fff',
    overflow: 'hidden',
    WebkitOverflowScrolling: 'touch' as 'touch',
    borderRadius: 4,
    outline: 'none',
    padding: 0,
    height: '100vh',
  },
};

interface Props {
  modalName: string;
  hideModal: () => void;
}

const modalComponentMap: { [key: string]: any } = {
  VIDEO_MODAL: VideoModal,
  ACCOUNT: AccountModal,
  ADD_SPOUSE_PROFILE: AddSpouseProfile,
  SPOUSE_PROFILE: SpouseProfile,
  ADD_ACCOUNT_OR_SPOUSE: AddAccountOrSpouse,
  SECURELY_ADD_ACCOUNTS: SecurelyAddAccounts,
  INCREASE_CONTRIBUTION: IncreaseContribution,
  DELAY_RETIREMENT: DelayRetirement,
  RETIREMENT_AGE: RetirementAgeModal,
  RETIREMENT_INCOME: RetirementIncomeModal,
  CONTRIBUTION_EDUCATION: ContributionEducationModal,
  DELETE_SPOUSE_MODAL: DeleteSpouseModal,
  CHART_EDUCATION: ChartEducationModal,
  TERMED_MODAL: TermedModal,
  SAVINGS_RUN_OUT: SavingsRunOutModal,
  CONFIDENCE_NUMBER: ConfidenceNumber,
  INFORMATION_AND_ASSUMPTIONS: InformationAndAssumptions,
  YODLEE_THIRD_PARTY: YodleeThirdParty,
  YODLEE_IFRAME: YodleeIFrame,
  YODLEE_REDIRECT: YodleeRedirect,
  DOLLAR_VALUE: DollarValue,
  CONTRIBUTION_SOURCE_MODAL: ContributionSourceModal,
  CONTRIBUTION_PER_PAYCHECK_MODAL: ContributionPerPaycheckModal,
  EDIT_CHART_DISPLAY_SETTINGS: EditChartDisplaySettings,
  RIX_ASSUMPTIONS: RIXAssumptions,
  LEARN_MORE_MODAL: LearnMoreModal,
  RIG_SALARY_MODAL: RIGSalaryModal,
  RIG_OTHER_INCOME_MODAL: RIGOtherIncomeModal,
  EVENTS: EventModal,
  FUTURE_INCOME_MODAL: FutureIncomeModal,
  ADD_FUTURE_EXPENSE: AddFutureExpense,
  ADD_FUTURE_INCOME: AddFutureIncome,
  DELETE_FUTURE_EXPENSE: DeleteFutureExpense,
  DELETE_FUTURE_INCOME: DeleteFutureIncome,
};

const desktop = window.matchMedia('(min-width: 768px)');
const mobile = window.matchMedia('(max-width: 767px)');
class ReactModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    Modal.setAppElement('#spa-root');
  }

  componentDidMount() {
    if (desktop.matches) {
      document.getElementsByTagName('html')[0].classList.add('fixed');
    }
    if (mobile.matches) {
      document.body.style.position = 'fixed';
      document.body.style.top = window.scrollY + 'px';
    }
  }

  componentWillUnmount() {
    if (desktop.matches) {
      document.getElementsByTagName('html')[0].removeAttribute('style');
    }
    if (mobile.matches) {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
  }

  render() {

    const { modalName, hideModal } = this.props;
    const ModalComponent = modalComponentMap[modalName];

    return (
      <Modal
        id={'modal-window'}
        shouldCloseOnOverlayClick={false}
        isOpen={modalName ? true : false}
        onRequestClose={hideModal}
        contentLabel="Modal"
        style={mobile.matches ? mobileStyles : desktopStyles}
        data={{ 'metrics-location': 'PU' }}
      >
        <ModalComponent />
      </Modal>
    );
  }
}

export default connect(null, { hideModal: modalActions.hideModal })(ReactModal);
